module.exports = __webpack_public_path__ + "webpc/img/icon_share_3.832d0d99.png";